import PlanInstanceReducer from './PlanInstanceReducer';
export default PlanInstanceReducer;
